import { createI18n } from 'vue-i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';

const STORAGE_KEY = 'castvo_locale';

function detectInitialLocale(): 'zh-CN' | 'en-US' {
  if (typeof window === 'undefined') return 'zh-CN';
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'zh-CN' || saved === 'en-US') return saved;
  // Chinese-first product: default to zh-CN regardless of browser language.
  // English is opt-in via the language switcher (top-right). We deliberately do
  // NOT auto-switch to English from navigator.language, because that surprised
  // Chinese users whose browser reports en-US and left the UI half-translated
  // on pages not yet fully i18n'd.
  return 'zh-CN';
}

export const i18n = createI18n({
  legacy: false,
  locale: detectInitialLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
});

export function setLocale(locale: 'zh-CN' | 'en-US'): void {
  i18n.global.locale.value = locale;
  localStorage.setItem(STORAGE_KEY, locale);
  // Reflect on <html> for accessibility tools
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
}

export type Locale = 'zh-CN' | 'en-US';
